<template>
    <div class="contain">
        <img class="imgs" src="../../../assets/c3/guide01.png" alt="솔닥 보습제 MD 비대면 진료 안내(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c3/guide02.png" alt="솔닥 보습제 MD 비대면 진료 안내(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c3/guide03.png" alt="솔닥 보습제 MD 비대면 진료 안내(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c3/guide04.png" alt="솔닥 보습제 MD 비대면 진료 안내(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c3/guide05.png" alt="솔닥 보습제 MD 비대면 진료 안내(다음 내용 참조)" />
        <img class="imgs" src="../../../assets/melanon_05.jpg" alt="" />
        <div class="sr-only">
            <h2>보습제 MD 비대면 진료로 간편하게</h2>
            <p>솔닥 앱을 통해 보습제 처방부터 배송, 서류발급까지 한 번에 해결하세요</p>
            <h3>앱으로 더욱 간편하게 진료받고 서류 발급까지 한 번에</h3>
            <p>솔닥 앱을 통해 간편한 진료 예약을 경험해 보세요! 진료 후 앱으로 서류 발급 및 조회가 가능해요</p>
            <h3>서비스 이용 수수료는 없어요</h3>
            <p>진료비, 약제비 외 이용 수수료가 없어 비용 부담없이 사용할 수 있어요</p>
            <h3>보습제가 문 앞까지 안전하게 배송돼요</h3>
            <p>병원에 재고 문의할 필요없이 편하고 안전하게 배송받을 수 있어요</p>
            <p>* 서울 전역 및 경기, 인천 일부 지역 당일 배송 가능 (오후 1시 이전 결제 시, 자세한 사항은 하단 FAQ 확인)</p>
            <h3>비대면진료는 영상/음성 통화로 진행돼요</h3>
            <p>상황에 따라 영상통화가 불가능한 경우에는 음성통화로 비대면진료를 진행할 수 있어요</p>
            <h3>솔닥에서 처방 가능한 보습제를 확인하세요</h3>
            <ul>
                <li>
                    <strong>에스트라</strong>
                    <ul>
                        <li>아토베리어 MD크림</li>
                        <li>아토베리어 MD로션</li>
                        <li>에스트라 MD크림</li>
                        <li>아토베리어 잇칭 크림MD</li>
                        <li>아토베리어 AI MD크림</li>
                        <li>더마 베이비 PRO 크림MD</li>
                        <li>더마 베이비 PRO 로션MD</li>
                    </ul>
                </li>
                <li>
                    <strong>제로이드</strong>
                    <ul>
                        <li>인텐시브 리치 MD크림</li>
                        <li>인텐시브 MD크림</li>
                        <li>인텐시브 MD로션</li>
                        <li>루트힐 모이스처라이저 MD</li>
                        <li>써지엔젤플러스MD</li>
                    </ul>
                </li>
                <li>
                    <strong>이지듀</strong>
                    <ul>
                        <li>이지듀 MD크림</li>
                        <li>이지듀 MD로션</li>
                        <li>이지듀 MD 리젠 크림</li>
                    </ul>
                </li>
                <li>
                    <strong>셀퓨전씨</strong>
                    <ul>
                        <li>엑스퍼트 배리덤 로션MD</li>
                        <li>엑스퍼트 배리덤 크림MD</li>
                        <li>엑스퍼트 배리덤 쉴드크림MD</li>
                    </ul>
                </li>
                <li>
                    <strong>그외</strong>
                    <ul>
                        <li>리쥬더마 아토크림MD</li>
                        <li>덱세릴MD크림</li>
                    </ul>
                </li>
            </ul>
            <h3>FAQ 자주 묻는 질문</h3>
            <p>보습제 MD 등 병원 판매 의료기기의 경우, 택배 배송 및 수령이 가능합니다.</p>
            <h4>보습제 수령(배송)에 대한 질문</h4>
            <div>
                <dl>
                    <dt>배송 가능 지역이 어떻게 되나요?</dt>
                    <dd>솔닥은 전국 어디든 배송이 가능합니다.</dd>
                </dl>
                <dl>
                    <dt>당일 배송이 가능한 지역은 어디인가요?</dt>
                    <dd>서울 전역과 인천, 경기 일부 지역은 평일 오후 1시 이전 결제 시 당일 배송이 가능합니다.</dd>
                </dl>
                <dl>
                    <dt>전 지역 서비스 가능 지역</dt>
                    <dd>서울, 성남, 부천, 안양, 과천, 수원</dd>
                </dl>
                <dl>
                    <dt>일부 지역 서비스 가능 지역</dt>
                    <dd>
                        <ul>
                            <li>고양 - 일산 서구/일산 동구/덕양구 화정동, 행신동</li>
                            <li>인천 - 부평구/계양구/미추홀구/남동구 간석동, 만수동, 구월동</li>
                            <li>하남 - 선동, 망월동, 감일동, 감이동, 함악동</li>
                            <li>광명 - 광명 1~5동, 철산 1~4동, 하안 2~4동, 소하 1~2동, 일직동</li>
                            <li>용인 - 수지구</li>
                            <li>남양주 - 다산동, 별내동</li>
                            <li>화성 - 능동, 반송동, 석우동, 영천동, 오산동, 청계동</li>
                        </ul>
                    </dd>
                </dl>
                <dl>
                    <dt>당일 배송 방법</dt>
                    <dd>
                        <ol>
                            <li>1. 월-목 오후 1시 이전 진료와 결제를 마무리해주세요</li>
                            <li>2. 수령 방법으로 '택배 수령'을 선택해주세요</li>
                            <li>3. 보습제가 당일 밤 10시까지 도착합니다</li>
                        </ol>
                    </dd>
                </dl>
            </div>
            <h4>비대면 진료 이용에 대한 질문</h4>
            <div>
                <dl>
                    <dt>비대면진료는 어떻게 보나요?</dt>
                    <dd>솔닥 앱을 통해 비대면 진료를 이용하실 수 있습니다. 솔닥 앱을 다운로드한 후, 간편하게 진료 예약을 할 수 있습니다. 
                        진료는 환자가 선택한 영상통화 또는 음성통화 방식으로 진행되며 처방약은 솔닥 앱을 통해 원하는 방법으로 수령할 수 있습니다.
                    </dd>
                </dl>
                <!-- <dl>
                    <dt>비대면 진료가 가능한 시간은 언제인가요?</dt>
                    <dd>휴일과 야간에는 누구나 비대면 진료를 받을 수 있습니다.
                        <ul>
                            <li>평일 : 오후 6시부터 다음날 오전 8시까지,</li>
                            <li>휴일 : 토요일 오후 1시부터 일요일 자정까지</li>
                            <li>공휴일 : 24시간 진료 가능</li>
                        </ul>
                    </dd>
                </dl>
                <dl>
                    <dt>비대면 진료가 가능한 대상은 누구인가요?</dt>
                    <dd>다음의 경우에 언제든지 비대면 진료를 받을 수 있습니다.
                        <ul>
                            <li>최근 6개월 이내에 해당 병원에 직접 방문하여 진료를 받은 경우</li>
                            <li>거주지가 의료취약지역에 해당하는 경우</li>
                        </ul>
                    </dd>
                </dl> -->
                <dl>
                    <dt>비대면진료 후 처방약은 어떻게 수령하나요?</dt>
                    <dd>처방약은 가까운 약국에서 픽업할 수 있습니다. 진료 후, 앱을 통해 인근 약국을 선택하고 처방전을 전송하세요.
                        선택한 약국에 방문하여 처방약을 수령하세요. <strong>보습제MD 등 병원 판매 의료기기의 경우, 택배 수령이 가능합니다.</strong>
                    </dd>
                </dl>
            </div>
        </div>
		<a href="https://abit.ly/md240205" class="c3-floot-cta" target="_blank" title="새 창 열림">			
			<img class="imgs" src="../../../assets/c19/img-cta-btn.png" alt="" />
		</a>
    </div>
</template>

<script>
// import axios from 'axios';
export default {
    name: 'c3',
    methods: {
        // goLink: function()
        // {
        //     window.open('http://bit.ly/3Xq9OFI', '_blank');
        // },
        // gokakao: function(eventname)
        // {
        //     this.conversionApi(eventname);
        //     window.criteo_q = window.criteo_q || [];
        //     var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        //     window.criteo_q.push(
        //         { event: "setAccount", account: 96598},

        //         // To Do 1. 현재 유저의 이메일 주소(공백 제거 및 소문자로 변환 후) 전달. 유저의 이메일을 알수 없는 상황이면 빈 문자열로 전달
        //         { event: "setEmail", email: "##User Email##" },

        //         // To Do 2. 현재 유저의 저장된 배송지 우편번호. 유저의 배송지 우편번호를 알수 없는 상황이면 빈 문자열로 전달
        //         { event: "setZipcode", zipcode: "##Zip Code##" },

        //         { event: "setSiteType", type: deviceType},

        //         // To Do 3. 확인 또는 주문 번호를 전달
        //         // Tip 1. 다른 종류의 전환일 경우 상품 ID에 다른 값으로 전달하여 나중에 리포트를 통해 확인 가능
        
        //         { event: "trackTransaction", id: Math.floor(Math.random()*99999999999), item: [
        //             {id: "1", price: 1, quantity: 1 }
        //         ]}
        //     );

        //     window.open('https://plus.kakao.com/talk/bot/@솔닥/솔닥%20원격진료%20시작하기', '_blank');
        // },
        // conversionApi: function(eventname)
        // {
        //     const time = Date.now();
        //     let stime = time.toString().slice(0, 10);
        //     const data = {
        //         data: 
        //         [
        //             {
        //                 event_name: eventname,
        //                 // text_event_code: "TEST43477",
        //                 event_time: Number(stime),
        //                 action_source: "email",
        //                 user_data: {
        //                     em: [
        //                         "7b17fb0bd173f625b58636fb796407c22b3d16fc78302d79f0fd30c2fc2fc068"
        //                     ],
        //                     ph: [
        //                         null
        //                     ]
        //                 },
        //                 custom_data: {
        //                     "currency": "USD",
        //                     "value": "142.52"
        //                 }
        //             }
        //         ]
        //     }
        //     return axios({
        //         method: 'post',
        //         url: 'https://graph.facebook.com/v15.0/580521327268842/events?access_token=EAAHIPxRrOeYBAHfdaUR70ZAZA8EamzQKUvK8aqMnrYkvKZALvCbi7C7Etg0n16uhtxUxRZCxAeZCaiWaUTM7yJs4wbkfZC3omvYc14FoImXXN1ciRHtBv2tZB3fCzeRb9ppQR9oP2aGJwqJVNR0btsZCOrhrj9s7KiGv3mnCPPNiOau6kUUG95nchnH5mSdOyBkZD.',
        //         data: data
        //     })
        // }
    }
}
</script>

<style scoped>
    .contain{
        width: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
    }
    .imgs  {
        width: 100%;
    }
    .contain .sr-only {
        position: absolute;
        left: -9999px;
        width: 1px;
        height: 1px;
        margin: 0 !important;
        font-size: 0;
        line-height: 0;
        overflow: hidden;
    }
    .c3-floot-cta{
        position: fixed;
        bottom: 15px;
        width: auto;
        padding: 0 33px;
        max-width: 100%;
        z-index: 10;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_view/contents/c3.vue